import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "card-footer"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-line"
}, null, -1);
import { useSlots } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CellCard',
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "orderCard",
        class: _normalizeClass(["order-card", {
          'order-card__footer': _unref(slots).footer
        }])
      }, [_renderSlot(_ctx.$slots, "default"), _unref(slots).footer ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _renderSlot(_ctx.$slots, "footer")])) : _createCommentVNode("", true)], 2);
    };
  }
});